//ToolButton
//***********************************************************************************************************************
import { Button, IconButton, Tooltip } from "@mui/material";
import * as React from "react";

export interface IToolButtonProp {
    removeDefaultClasses?: boolean;
    stopPropagation?: boolean;
    title?: string | React.ReactNode;
    classes?: string;
    variant: "outlined" | "contained" | "text" | "icon";
    tooltip?: string;
    icon?: React.ReactNode;
    disabled?: boolean;
    onClick: () => void;
}

export class ToolButton extends React.Component<IToolButtonProp, {}> {
    handleClick = (e) => {
        const props = this.props;
        if (!!props.disabled || !props.onClick) return;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
        props.onClick();
    };

    render() {
        const props = this.props;
        const tooltip = props.tooltip ? props.tooltip : (typeof props.title === "string" ? props.title : null);
        return (
            <Tooltip title={!props.disabled && tooltip}>
                <span>
                    {props.variant !== "icon"
                        ? (
                            <Button variant={props.variant} onClick={this.handleClick} disabled={props.disabled} startIcon={(props.title && props.icon) ? props.icon : null}>{props.title ? props.title : props.icon}</Button>
                        )
                        : (
                            <IconButton onClick={this.handleClick} disabled={props.disabled}>{props.icon}</IconButton>
                        )}
                </span>
            </Tooltip>
        );
    }
}

// export interface IToolAddFileButtonProp {
//     removeDefaultClasses?: boolean;
//     stopPropagation?: boolean;
//     accept?: string;
//     title?: string | JSX.Element;
//     tooltip?: string;
//     classes?: string;
//     disabled?: boolean;
//     fileInputName: string;
//     onChange: (fileList: FileList) => void;
// }

// export class ToolAddFileButton extends React.Component<IToolAddFileButtonProp, {}> {
//     handleClick = (e) => {
//         const props = this.props;
//         if (props.stopPropagation) {
//             e.stopPropagation();
//         }
//     };

//     handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const props = this.props;
//         if (props.disabled) return;
//         if (props.stopPropagation) {
//             e.stopPropagation();
//         }
//         if (!e.target.files || e.target.files.length < 1) return;
//         this.props.onChange(e.target.files);
//     };

//     render() {
//         const props = this.props;
//         const hasTitle = !!props.title;
//         const tooltip = props.tooltip ? props.tooltip : (typeof props.title === "string" ? props.title : null);
//         const buttonClasses = (props.removeDefaultClasses ? "" : "btn btn-tool") + (props.classes ? " " + props.classes : "") + (props.disabled ? " disabled" : "") + (hasTitle ? " text" : "");
//         if (!props.disabled) {
//             return (
//                 <label className={buttonClasses} title={tooltip} onClick={this.handleClick}>
//                     <span className="icon" aria-hidden="true">
//                         <input type="file" name={this.props.fileInputName} className="file" style={{ display: "none" }} multiple={true} accept={props.accept} onChange={this.handleChange} />{hasTitle && <br />}{props.title}
//                     </span>
//                 </label>
//             );
//         }
//         return (
//             <button type="button" className={buttonClasses} title={tooltip}><span className="icon" aria-hidden="true"></span>{hasTitle && <br />}{props.title}</button>
//         );
//     }
// }